module.exports = __webpack_public_path__ + "img/icon_02.2c33793e.png";